
export default {
  methods: {
    handleClickDeleteButton: function handleClickDeleteButton() {
      this.$emit('delete');
    }
  }
};